import { render, staticRenderFns } from "./CompanyPlanningConfig.vue?vue&type=template&id=56b0eb3b&scoped=true&"
import script from "./CompanyPlanningConfig.vue?vue&type=script&lang=js&"
export * from "./CompanyPlanningConfig.vue?vue&type=script&lang=js&"
import style0 from "./CompanyPlanningConfig.vue?vue&type=style&index=0&id=56b0eb3b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b0eb3b",
  null
  
)

export default component.exports